@if (canLoginToSupport$ | async) {
    <adapt-sidebar-tab-icon [iconClass]="iconClass"
                            iconText="Help"
                            (click)="navigateToSupport()"></adapt-sidebar-tab-icon>
} @else {
    <adapt-sidebar-tab-icon [iconClass]="iconClass"
                            iconText="Help"> </adapt-sidebar-tab-icon>
}
